<template>
  <t-navigation-drawer v-slot="{ close }" ref="drawer">
    <div class="close-drawer-item">
      <a class="close-drawer-btn" @click="close"><CloseIcon class="btn-close-icon"/></a>
    </div>
    <t-router-link color="var(--on-header)" to="/cursos" @click.native="close" v-if="$config.featureFlags['EXIBIR_MENU_CURSOS']">
      <span v-html="$config.strings['header-btn-1']"/>
    </t-router-link>
    <t-router-link color="var(--on-header)" to="/regulamento" @click.native="close" v-if="$config.featureFlags['EXIBIR_MENU_REGULAMENTO']">
      <span v-html="$config.strings['header-btn-2']"/>
    </t-router-link>
    <t-router-link color="var(--on-header)" to="/cadastrar" @click.native="close" v-if="$config.featureFlags['EXIBIR_MENU_CADASTRAR']">
      <span v-html="$config.strings['header-btn-9']"  />
    </t-router-link>
     <t-router-link color="var(--on-header)" to="/lojas" @click.native="close" v-if="$config.featureFlags['EXIBIR_MENU_LOJA']">
      <span v-html="$config.strings['header-btn-8']"/>
    </t-router-link>
    <t-router-link color="var(--on-header)" to="/consultar-raspadinha" @click.native="close" v-if="$config.featureFlags['EXIBIR_MENU_CONSULTAR_RASPADINHA']">
      <span v-html="$config.strings['RASPADINHA_header-btn-3']"/>
    </t-router-link>
    <t-router-link color="var(--on-header)" to="/ganhadores" @click.native="close" v-if="$config.featureFlags['EXIBIR_MENU_GANHADORES']">
      <span v-html="$config.strings['header-btn-3']"/>
    </t-router-link>
    <t-router-link color="var(--on-header)" to="/contato" @click.native="close" v-if="$config.featureFlags['EXIBIR_MENU_CONTATO']">
      <span v-html="$config.strings['header-btn-4']"/>
    </t-router-link>
    <t-router-link color="var(--on-header)" to="/numero-da-sorte" @click.native="close" v-if="$config.featureFlags['EXIBIR_MENU_NUMEROSORTE']">
      <span v-html="$config.strings['header-btn-5']"/>
    </t-router-link>
  </t-navigation-drawer>
</template>

<script>
import CloseIcon from '@/assets/close.svg'
import { TRouterLink, TNavigationDrawer } from '@/components/base'
export default {
  name: 'nav-drawer',
  components: { TRouterLink, TNavigationDrawer, CloseIcon },
  mounted () {
    this.$events.$on('OPEN_DRAWER', this.$refs.drawer.open)
  },
  beforeDestroy () {
    this.$events.$off('OPEN_DRAWER')
  },
  methods: {
    loginRedirect () {
      location.href = this.$config.urls.login_url
    }
  }
}
</script>

<style lang="scss" scoped>
.close-drawer-item {
  padding: 10px;
  display: flex;
  justify-content: flex-end;

  .close-drawer-btn {
    padding: 10px 15px;
    text-align: right;
    border-radius:35px;
    font-weight: bolder;
    font-size: 16px;
    color: var(--on-header);
  }
}

.btn-close-icon {
  cursor: pointer;
  height: 20px;
  width: 20px;
  margin-left: 15px;
  fill: var(--secondary);
}

.nav-btn-login {
  width: 176px;
  background-color: var(--secondary);
  color: var(--on-secondary);
}

.nav-primeiro-acesso-title {
  width: 100%;
  text-align: left;
  margin-top: 30px;
  cursor: pointer;

  a {
    color: var(--on-primary);
    text-align: center;
    margin: 15px 0;
    width: 100%;
    font-size: 14px;
    text-decoration: underline;
  }
}
</style>
